import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import { ReactComponent as IconHunting } from '../../assets/icons/crosshairs.svg';
import { ReactComponent as IconHiking } from '../../assets/icons/OutdoorActivities/icon-hiking.svg';
import { ReactComponent as IconClock } from '../../assets/icons/clock-regular.svg';
import { ReactComponent as IconUser } from '../../assets/icons/icon-user.svg';
import css from './PackageItinerary.module.css';
import { getPackageItineraryData } from '../../util/transaction';

const PackageItinerary = props => {
  const {
    activity,
    className,
    rootClassName,
    startDate,
    endDate,
    hasLodging,
    listing,
    bookingGuestSize,
    isProvider,
    startLodgingDate,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const arrivalInstructions = get(listing, 'attributes.publicData.arrivalInstructions');

  // Use the shared helper function to get all the formatted data
  const itineraryData = getPackageItineraryData({
    activity,
    startDate,
    endDate,
    hasLodging,
    listing,
    bookingGuestSize,
    isProvider,
    arrivalInstructions,
    startLodgingDate,
  });

  // Extract the data we need for display
  const { title, dates, descriptions } = itineraryData;

  const getActivityIcon = () => {
    switch (activity) {
      case 'hunt':
        return <IconHunting />;
      case 'outdoor_recreation':
        return <IconHiking />;
      default:
        return <IconHiking />;
    }
  };

  const events = [
    {
      icon: <IconClock />,
      subtitle: dates.checkIn,
      title: title.checkIn,
      description: descriptions.checkIn,
      id: 'check-in',
    },
    {
      icon: getActivityIcon(),
      subtitle: dates.activity,
      title: title.activity,
      description: descriptions.activity,
      id: 'hunting-days',
    },
    {
      icon: <IconClock />,
      subtitle: dates.checkOut,
      title: title.checkOut,
      description: descriptions.checkOut,
      id: 'check-out',
    },
  ];

  // Add guest size information to events if provided
  if (bookingGuestSize) {
    events.unshift({
      icon: <IconUser />,
      subtitle: '',
      title: title.guestSize,
      description: '',
      id: 'guest-size',
    });
  }

  return (
    <div className={classes}>
      <div className={css.header}>Trip Details</div>
      <div className={css.timeline}>
        {events.map(event => (
          <div key={event.id} className={css.event}>
            <div className={css.eventIconContainer}>
              <div className={css.eventIcon}>{event.icon}</div>
            </div>
            <div className={css.eventContent}>
              <div className={css.eventTitle}>{event.title}</div>
              {event.subtitle && <div className={css.eventSubtitle}>{event.subtitle}</div>}
              {event.description && <div className={css.eventDescription}>{event.description}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

PackageItinerary.defaultProps = {
  rootClassName: null,
  className: null,
  bookingGuestSize: null,
  startLodgingDate: null,
};

PackageItinerary.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  startDate: PropTypes.instanceOf(Date).isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  hasLodging: PropTypes.bool.isRequired,
  listing: PropTypes.object.isRequired,
  bookingGuestSize: PropTypes.number,
  startLodgingDate: PropTypes.instanceOf(Date),
};

export default PackageItinerary;
